export const ArrowUpGreen = ({ ...props }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.778177 5.82143L6.49246 0.392857C6.76814 0.130571 7.12193 6.55427e-07 7.47628 6.24448e-07C7.83064 5.93469e-07 8.18443 0.130571 8.46011 0.392857L14.1744 5.82143C14.7464 6.36496 14.7698 7.26896 14.2263 7.8415C13.6822 8.41071 12.7771 8.43529 12.2067 7.89286L8.90486 4.75643L8.90486 14.5714C8.90486 15.3605 8.26536 16 7.47628 16C6.68721 16 6.04771 15.3605 6.04771 14.5714L6.04771 4.75643L2.74582 7.89286C2.17496 8.43529 1.26982 8.41182 0.726284 7.8415C0.182784 7.26897 0.206213 6.36496 0.778177 5.82143Z"
        fill="#1D8D3C"
      />
    </svg>
  )
}
